import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	partDefinition: null
};

const designDefinitionSlice = createSlice({
	name: 'designDefinition',
	initialState,
	reducers: {
		setDesignDefinition: (state, action) => {
			state.partDefinition = action.payload;
		}
	}
});

export const { setDesignDefinition } = designDefinitionSlice.actions;

export default designDefinitionSlice.reducer;
